import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { RecentMatter } from '@/api/types/backend-dto-types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetRecentMatters = () => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<RecentMatter[]>(
    [QueryEntity.RecentMatters],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/matters/recent`, fetchConfigGET);

      if (!res.ok) {
        throw new Error('Failed to get recent Matters');
      }

      return await res.json();
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
    },
  );
};
